"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
class index extends react_1.Component {
    render() {
        return (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.TouchableOpacity, { style: { height: 30, width: 60, borderColor: 'black', borderWidth: 1, justifyContent: 'center', alignItems: 'center' } },
                react_1.default.createElement(react_native_1.Text, null, "Ngocphuc")),
            react_1.default.createElement(react_native_1.Text, null, " helllo every one ")));
    }
}
exports.default = index;
